import { render, staticRenderFns } from "./ConfigureSettingsNewTemp.vue?vue&type=template&id=41f8f505&scoped=true"
import script from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNewTemp.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNewTemp.vue?vue&type=style&index=0&id=41f8f505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f8f505",
  null
  
)

export default component.exports